<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path
      d="M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z"
      fill="#6A49EF"
      stroke="#6A49EF"
      stroke-width="2" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.889 9.41227L12.7298 17.5933L10.1082 14.5979C9.62698 14.0482 8.84421 14.0482 8.36299 14.5979C7.879 15.1507 7.879 16.0448 8.36299 16.5945L11.8562 20.5879C12.0978 20.8616 12.4125 21 12.7298 21C13.0445 21 13.3618 20.8616 13.6042 20.5879L21.637 11.409C22.121 10.8561 22.121 9.96512 21.637 9.41227C21.1558 8.86258 20.373 8.86258 19.889 9.41227Z"
      fill="white" />
  </svg>
</template>

<script>
  export default {
    name: "CheckmarkIcon",
  };
</script>

<style></style>
